import { useTranslation } from 'react-i18next';
import styles from 'typescript/components/product_groups/color_product_group.module.scss';
import ColorSelection from 'typescript/components/product_groups/color_selection';

export const COLOR_PRODUCT_GROUP_DATA_TEST_ID = 'color-product-group';
export const COLOR_PRODUCT_GROUP_COLOR_NAME_TEST_ID =
  'color-product-group-color-name';

export type ColorProduct = {
  name: string;
  productKey: string;
  variantId: number;
  slug: string;
  displayName: string;
  hexColor: string;
  inStock: boolean;
};

interface ColorProductGroupProps {
  titleOverride?: string;
  selectedProduct?: ColorProduct;
  products: ColorProduct[];
  onProductSelected?: (product: ColorProduct) => void;
}

const ColorProductGroup = ({
  titleOverride,
  selectedProduct,
  products,
  onProductSelected,
}: ColorProductGroupProps) => {
  const { t } = useTranslation();

  if (products.length === 0) {
    return null;
  }

  const sortedProducts = products.sort((a, b) => {
    // Show in stock products first
    return Number(b.inStock) - Number(a.inStock);
  });

  return (
    <div
      data-testid={COLOR_PRODUCT_GROUP_DATA_TEST_ID}
      className={styles.container}
    >
      <label className={styles.title}>
        {titleOverride || t('productPage.colorProductGroup.title')}
      </label>
      <label
        data-testid={COLOR_PRODUCT_GROUP_COLOR_NAME_TEST_ID}
        className={styles.colorName}
      >
        {selectedProduct?.displayName || selectedProduct?.name}
      </label>
      <div className={styles.colorsContainer}>
        {sortedProducts.map((product) => (
          <ColorSelection
            key={product.slug}
            state={product.inStock ? 'in_stock' : 'out_of_stock'}
            selected={selectedProduct?.productKey === product.productKey}
            hexCode={product.hexColor}
            onSelected={() => {
              onProductSelected && onProductSelected(product);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ColorProductGroup;
